import { SVGProps } from 'react';

export const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 17.4542C7.45636 17.4542 3.76473 13.5531 2.47527 11.9986C3.76145 10.4429 7.44 6.5451 12 6.5451C16.5436 6.5451 20.2353 10.4462 21.5247 12.0007C20.2385 13.5564 16.56 17.4542 12 17.4542ZM23.8004 11.3713C23.5996 11.0855 18.7876 4.36328 12 4.36328C5.21236 4.36328 0.400364 11.0855 0.199636 11.3713C-0.0665455 11.7487 -0.0665455 12.2506 0.199636 12.628C0.400364 12.9138 5.21236 19.636 12 19.636C18.7876 19.636 23.5996 12.9138 23.8004 12.628C24.0665 12.2506 24.0665 11.7487 23.8004 11.3713Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 14.1815C10.7967 14.1815 9.81818 13.2029 9.81818 11.9996C9.81818 10.7975 10.7967 9.81783 12 9.81783C13.2033 9.81783 14.1818 10.7975 14.1818 11.9996C14.1818 13.2029 13.2033 14.1815 12 14.1815ZM12 7.63601C9.59345 7.63601 7.63636 9.5931 7.63636 11.9996C7.63636 14.4062 9.59345 16.3633 12 16.3633C14.4065 16.3633 16.3636 14.4062 16.3636 11.9996C16.3636 9.5931 14.4065 7.63601 12 7.63601Z"
      fill="currentColor"
    />
  </svg>
);
